/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow } from '../GridsAndLayouts';
import { CheckCircleIcon } from '../Icons/CheckCircleIcon';
import { ThumbsUpIcon } from '../Icons/ThumbsUpIcon';

export function FeedIconCheckCircle({ className = '' }) {
  return (
    <FlexRow inline fullWidth={false} align="center" justify="center" className={className}>
      <CheckCircleIcon size={16} />
    </FlexRow>
  );
}

FeedIconCheckCircle.propTypes = {
  className: PropTypes.string,
};

export function FeedIconThumbsUp({ className = '' }) {
  return (
    <FlexRow inline fullWidth={false} align="center" justify="center" className={className}>
      <ThumbsUpIcon size={16} variant="filled" />
    </FlexRow>
  );
}

FeedIconThumbsUp.propTypes = {
  className: PropTypes.string,
};
